import React, { FC } from 'react'
import { DayOfWeekType } from 'lib/daysOfWeek'
import { TextButton } from './index'

type Props = {
  daysOfWeek: DayOfWeekType[]
  unselectAll: () => void
  selectAll: () => void
}

const SelectDaysOfWeekButton: FC<Props> = (props) => {
  const { daysOfWeek, selectAll, unselectAll } = props
  return (
    <TextButton
      label={daysOfWeek.length === 0 ? '全曜日選択する' : '全曜日選択解除する'}
      onClick={daysOfWeek.length === 0 ? selectAll : unselectAll}
    />
  )
}

export default SelectDaysOfWeekButton
